/**
 * Created by mykurisu on 2017/12/6.
 */
import React from 'react'
import axios from 'axios'
import {Toast, Mask} from 'react-weui'
import {connect} from 'react-redux'
import { Link, browserHistory } from 'react-router'
import cn from 'classnames'
import ActivityBagForNew from '../../../../components/activity/couponSPA/ActivityBagForNew'
import DrawLottery from '../../../../components/activity/couponSPA/DrawLottery'
import {renderMoney, isLZWKAPP, TimeStream, randomArr, isIos} from '../../../../utils'
import {toChannel} from '../../../../utils/connectApp'
import {avatar_list} from '../../../../utils/avatar_list'
import Item from '../CouponItem'
import AnimationItem from '../AnimationItem'
import config from '../../../../config'

import '../../../../css/page/CouponSPA.css'
import headerLuckImg from '../../../../images/activity/couponspa/header-luck.png'
import couponBgImg from '../../../../images/activity/couponspa/coupon-bg.png'
import richerImg from '../../../../images/activity/couponspa/richer.png'
import wishCardBgImg from '../../../../images/activity/couponspa/wish-card-bg.png'
import spaBannerImg from '../../../../images/activity/couponspa/spa-banner.png'
import noPrizeHeaderImg from '../../../../images/activity/couponspa/no-prize-header.png'
// 测试用的inviter_id
// const inviters = ['36266813', '36266814', '36266815', '36266816', '36266817', '36266818', '36266819']
const inviters = ['44814268', '44006949', '44814193', '44318813', '44814310', '44814368', '44814415', '44814460', '45269110', '46717336', '44814415', '44814460', '50005617']


class CouponV1 extends React.Component {

    constructor(props) {
        super(props)
        const bagId = +props.location.query.bagid
        //如果bagId>14!==19去另一种券包页
        if (bagId > 14 && bagId!==22 && !isLZWKAPP() && bagId !== 19) {
            location.assign(`/specials/activity/coupon_timeline?bag_id=${bagId}&inviter_id=${this.getInviterId()}`)
        }
        this.isHidePrize = !!props.location.query.is_hide_prize
        this.isNewPeople = !!props.location.query.is_new_people
        this.version = props.location.query.version   //增加版本号作为迭代
        this.state = {
            beginShowTime: false,
            channels: [],
            isInit: false,
            is_join: false,
            originIsJoin: false,

            remainder_number: 0,
            used_channels: [],
            end_time: '',
            isPending: false,
            coupon_number: 0,
            price: 0,
            redpacketsPos: this.redpacketsPos,
            isZoomIn: false,
            isRedpacketExchanging: true,
            isFirstJoin: false,
            isPopRedpacketDialog: +props.location.query.pop_card === 1,

            wishCardAvatar: '',
            wishCardImg: '',
            wishCardText: '',

            //fake_content
            animation_content: '',
            prizeRemainCount: 0,
            prizeCanShowChannel: false,

        }
    }

    componentDidMount() {
        let img = new Image(0, 0);
        img.src = headerLuckImg;
        new Image(0, 0).src = spaBannerImg;
        const bagid = this.props.location.query.bagid
        const pop_luckyshare = this.props.location.query.pop_luckyshare
        if (!bagid) {
            return location.assign('/')
        }
        if (+this.props.location.query.pop_card === 1) {
            // this.setRedpacketsPos()
            this.mta('couponspa_wish_card_show')
        }
        if (Number(pop_luckyshare) === 1) {
            this.setState({
                prizeShareShown: true
            })
        }
        if (this.isHidePrize) {
            this.fetchInfo(bagid)
        } else {
            this.fetchLuckydrawInfo(bagid)
        }
    }

    fetchLuckydrawInfo (bagid) {
        let data = {}
        if (this.props.location.query.lucky_inviter_id) {
            data.lucky_inviter_id = this.props.location.query.lucky_inviter_id
        }
        axios.get(`/api/coupon/weike_active/${bagid}/luckydraw/init`, {
            params: data
        })
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        prizeRemainCount: res.data.data.remain_count,
                        prizeHasCouplet: res.data.data.has_couplet
                    }, () => {
                        this.fetchInfo(bagid)
                    })
                }
            })
    }

    componentWillUnmount () {
        this.fake_animation && clearInterval(this.fake_animation);
        this.begin && clearInterval(this.begin);
    }

    mta (payload) {
        this.props.dispatch({ type: 'MTA_CLICK', payload });
    }


    fetchInfo (bagid) {
        const query = this.props.location.query
        let params = +query.pop_card === 1 ? {
            pop_card: query.pop_card,
            bag_inviter_id: query.bag_inviter_id,
            template_id: query.template_id,
            greettext: query.greettext,
        } : {}
        if (query.pop_luckyshare) {
            params.pop_luckyshare = 1
        }
        axios.get(`/api/coupon/weike_active/${bagid}/info`, {
            params: params
        })
            .then(res => {
                const resData = res.data.data
                const originIsJoin = resData.is_join
                if (+query.pop_card === 1) {
                    // resData.is_join = false
                }
                if (!resData.is_join) {
                    this.mta('couponspa_random_rp_show')
                }
                if (res.data.code === 0) {
                    // 过期就闪人
                    if (resData.status === 'deadline') {
                        return location.assign('/')
                    }
                    if (+query.is_auto_receive === 1) {
                        // this.fetchGetCoupon(bagid)
                    }
                    this.mta(`new_coupon_spa_enter_${bagid}`)
                    document.title = resData.title;
                    if (!resData.is_join && !this.props.location.query.get_coupon){
                        this.mta(`new_coupon_spa_btnshow_${bagid}`)
                    }
                    // if (+query.pop_card !== 1) {
                    //     setTimeout(() => {
                    //         this.randomRedpackets()
                    //     }, 300)
                    // }
                    this.setState({
                        remainder_number: resData.remainder_number,
                        used_channels: resData.used_channels,
                        is_join: resData.is_join,
                        originIsJoin: originIsJoin,
                        end_time: resData.end_time,
                        channels: resData.channels,
                        coupon_number: resData.coupon_number,
                        price: resData.price,
                        isInit: true,
                        wishCardAvatar: resData.inviter_info && resData.inviter_info.account.small_avatar_url,
                        wishCardImg: resData.inviter_info && resData.inviter_info.theme.avatar,
                        wishCardText: resData.inviter_info && resData.inviter_info.greettext,

                        prizeCanShowChannel: resData.is_join,
                    }, () => {
                        if (!this.state.is_join && (this.state.prizeRemainCount === 0 || this.isHidePrize)) {
                            this.fetchGetCoupon (bagid)
                        }
                    });
                    this.handleFaker()
                    this.initShareData(resData, bagid)
                }
                else {
                    location.assign('/')
                }
            });
    }
    getInviterId () {
        let from
        const wkFrom = this.props.location.query.wk_from
        from = wkFrom ? wkFrom : this.props.location.query.from
        const queryInviterId = this.props.location.query.inviter_id
        if (queryInviterId) return queryInviterId
        switch (from) {
            case 'back_subscribed':
                return inviters[0]
            case 'back_no_subscribed':
                return inviters[1]
            case 'article':
                return inviters[2]
            case 'app':
                return inviters[3]
            case 'wx_share':
                return inviters[4]
            case 'home':
                return inviters[5]
            case 'schedule':
                return inviters[6]
            case 'card_sharelink':
                return inviters[7]
            case 'sharecard':
                return inviters[8]
            case 'index_gap':
                return inviters[10]
            case 'mywk_gap':
                return inviters[11]
            case 'taxiang':
                return inviters[12]
            default:
                return inviters[9]
        }
    }
    initShareData (data, bagid) {
        let share_info = +bagid === 8 ?{
            share_description : "你有28位好友已领取，就差你了",
            share_icon : "http://static-1253442168.cosgz.myqcloud.com/new_people/%E5%88%86%E4%BA%AB%E5%A4%B4%E5%83%8F%403x.png",
            share_title : "新人报到大礼包",
            share_url : config.MAIN_URL + '/specials/newreports_transfer'
        } : data.share_info
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: share_info.share_title,
                desc: share_info.share_description,
                imgUrl: share_info.share_icon,
                type: 'link',
                link: share_info.share_url,
                is_resell: '1',
                successCallback: () => {
                    this.mta('luckydraw_share_success')
                }
            }
        });
    }
    //自动获取红包
    fetchGetCoupon (bagid) {
        const inviterId = this.getInviterId()
        const {query} = this.props.location;
        let data = new FormData();
        data.append('bag_inviter_id', query.bag_inviter_id || 0);
        axios.post(`/api/coupon/weike_active/${bagid}/receive_coupons/${inviterId}`, data)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({
                        is_join: true,
                        isFirstJoin: true,

                        prizeCanShowChannel: true
                    })
                    this.handleFaker()
                } else {
                    // location.assign('/')
                }
            })
            .catch(err => alert('系统繁忙，请稍后再试'))
    }

    handleGetCoupon(bagid) {
        this.fetchGetCoupon(bagid)
        this.mta(`new_coupon_spa_btnclick_${bagid}`)
    }

    //初始化"买了课程"那个东西浮层
    handleFaker() {
        if (this.fake_animation) {
            return
        }
        let raw_list = avatar_list;
        let result = [];

        let avatar_num = 10;

        for (let i = 0;i < avatar_num;i++){
            let random = Math.floor(Math.random() * (raw_list.length - i));
            result.push(raw_list[random]);
            raw_list[random] = raw_list[raw_list.length - i - 1];
        }

        let list = [
            {img: result[0], time: '3'},
            {img: result[1], time: '4'},
            {img: result[2], time: '5'},
            {img: result[3], time: '6'},
            {img: result[4], time: '6'},
            {img: result[5], time: '7'},
            {img: result[6], time: '8'},
            {img: result[7], time: '8'},
            {img: result[8], time: '9'},
            {img: result[9], time: '9'}
        ];

        let index = -1;

        this.setState({
            animation_content: list[0]
        }, () => {
            index = 0
        });

        this.fake_animation = setInterval(() => {
            if (index === 9){
                index = 0
            }else {
                index = index + 1
            }
            this.setState({
                animation_content: list[index]
            })
        }, 2300)
    }

    onClickWishCard (e) {
        this.mta('couponspa_click_wish_card')
        this.setState({ isPopRedpacketDialog: false })
        // this.setState({ isPopRedpacketDialog: false, isRedpacketExchanging: false }, () => {
        //     this.onClickRedpacket(1, this.props.location.query.bagid)
        // })
    }

    //从抽奖组件传递上来的参数调用自动获取红包，
    fetchGetCouponAuto(v){
        this.fetchGetCoupon(v)
    }

    jumpToContent() {
        const redPacketLectureArea = this.refs.redPacketLecture.getBoundingClientRect().top
        window.scrollTo (0, redPacketLectureArea)
    }

    render() {
        const {
            channels, used_channels, end_time, is_join, isFirstJoin, isPopRedpacketDialog,
            remainder_number, coupon_number, price, redpacketsPos, isInit, wishCardAvatar,
            wishCardImg, wishCardText, isRedpacketExchanging, prizeList, prizeActivedId
        } = this.state
        const ActivityBarForNewParams = {
            remainder_number,price
        }
        const bagid = this.props.location.query.bagid
        const isAutoReceive = +this.props.location.query.is_auto_receive === 1
        const inviterId = this.getInviterId()
        const iosAppLzb = Number(this.props.location.query.bagid) === 13 && isIos() && isLZWKAPP()

        if (!isInit) {
            return (
                <div className="wk-page couponspa-no-init">
                    <Toast show={true} icon={'loading'} />
                </div>
            )
        }

        // 优惠券页
        return (
            <div className="activity__couponspa">

                {/* 心意卡弹窗 */}
                {
                    isPopRedpacketDialog && (
                        <div className="wish-card-dialog">
                            <Mask />
                            <div className="wish-card" onClick={e => this.onClickWishCard(e)}>
                                <img className='wish-card-bg' src={wishCardBgImg} alt="" />
                                <button className='wish-card-btn'>去领取</button>
                                <div className="text">
                                    <p style={{textIndent: 0}}><b>Dear:</b></p>
                                    <p>{wishCardText}</p>
                                </div>
                                <img className='wish-card-img' src={wishCardImg} alt='' />
                                <img className="avatar" src={wishCardAvatar} alt='' />
                            </div>

                        </div>
                    )
                }

                {/* 心意卡入口 */}
                {/* <div className="container__wallet-entry" onClick={() => window.location = `/specials/giftcard?bagid=${bagid}&k_from=coupon_top`}>
                    <span className="sharecard-slide-page-tips_icon">
                        <img src="https://static-1253442168.image.myqcloud.com/picture/5459246_faab50a9d6b2ad5fdb519e3a1fed6eb5.jpg" alt=""/>
                    </span>
                    <span>
                         {isLZWKAPP() ? '领现金' : '送心意'}
                    </span>
                </div> */}

                {/* 购买动画 xxx买了课程动画 */}
                {this.state.prizeCanShowChannel &&
                <AnimationItem content={this.state.animation_content}/>
                }

                <Toast show={this.state.isPending} icon={'loading'} />


                { !this.isHidePrize &&
                <DrawLottery  {...this.props} content={this.props.content} activedId={this.props.activedId} fetchGetCouponAuto={(v)=>this.fetchGetCouponAuto(v)} prizeCanShowChannel={this.state.prizeCanShowChannel}/>
                }


                { this.isHidePrize && !this.isNewPeople &&
                <div className="no-prize-header">
                    <img src={noPrizeHeaderImg} alt="" />
                </div>
                }

                {
                    //新人红包头部
                    this.isNewPeople && this.isHidePrize &&
                    <div onClick={() => this.jumpToContent()}>
                        <ActivityBagForNew coupon={ActivityBarForNewParams} />
                    </div>
                }





                {/* 抽到红包后才显示以下内容 */}
                {this.state.prizeCanShowChannel &&
                <div className="prize__container">
                    {/*当有券的时候显示 */}
                    { !this.isNewPeople &&  (
                        <div className="isHidePriceAndNoNewPeople">
                            <div className={`has-coupon-wrap ${remainder_number > 0 ? '' : 'hide'}`}>
                                <div className="header" style={this.isHidePrize ? {paddingTop: 0} : {}} ref={r => this.header = r}>
                                    {/*<div className="spa-banner">*/}
                                    {/*<img src={spaBannerImg} alt=""/>*/}
                                    {/*</div>*/}
                                    {
                                        isFirstJoin && <div className="title">恭喜你！获得{(price * coupon_number).toFixed()}元微课红包</div>
                                    }
                                    {
                                        !isFirstJoin && remainder_number > 0 && (
                                            <div className="title">你有{(price * remainder_number).toFixed()}元红包未使用</div>
                                        )
                                    }

                                    <div className="intro">（内含{+price}元现金券{remainder_number}张）</div>
                                </div>

                                <div className="coupon" style={{backgroundImage: `url(${couponBgImg})`}}>
                                    <div className="money">
                                        <span>￥</span>
                                        <span className="big">{+price}</span>
                                    </div>
                                    <div className="title">
                                        <span>无门槛现金券</span>
                                        {
                                            isFirstJoin && <span>{remainder_number}张</span>
                                        }
                                    </div>
                                    <div className="time">有效期至：{end_time && TimeStream(end_time, 'YMD')}</div>
                                </div>
                            </div>

                            <div className={`no-coupon-wrap ${remainder_number === 0 ? '' : 'hide'}`}>
                                <img src={richerImg} alt=""/>
                                <div className="text">
                                    <p>土豪，你领取的优惠券已全部使用</p>
                                    <p>微课妹妹正快马加鞭筹备下期活动</p>
                                </div>
                            </div>
                        </div>
                    )}




                    <div className="couponspa__showTime">
                        <img className="slogan_xjq" onClick={() => this.jumpToContent()} src="https://static-1253442168.image.myqcloud.com/picture/8173011_374b0d8eaa3bbf0f866b451c0f663ccb.jpg-picmsg420" alt=""/>

                        <div className="coupons-wrap" ref="redPacketLecture">
                            <div className="couponspa__list">
                                {
                                    channels.map(item => {
                                        if (used_channels.indexOf(item.id) < 0) {
                                            return (
                                                <Item
                                                    key={item.id}
                                                    content={item}
                                                    dispatch={this.props.dispatch}
                                                    is_join={is_join}
                                                    inviterId={inviterId}
                                                    price={price}
                                                />
                                            )
                                        }
                                    })
                                }
                            </div>

                            {
                                remainder_number > 0 && (
                                    <div className="tip">
                                        * 本活动页优惠专栏不定期更新，看上了请及时购买
                                    </div>
                                )
                            }


                            {
                                used_channels.length > 0 && (
                                    <div className="more" style={{paddingTop: remainder_number === 0 ? '0' : '15px'}}>
                                        <Link to='/account/bought'>{'>> 查看购买记录 <<'}</Link>
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}


export default connect((state) => ({}))(CouponV1)




// WEBPACK FOOTER //
// ./src/pages/ActivityPage/Coupon/CouponVersion/CouponV1.js